module.exports = __webpack_public_path__ + "static/media/lightning-in-bottle.44782644.mp3";